import React, { useState } from "react";
import { Link } from "react-router-dom";

const PrivacyTermsConditions = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  return (
    <div className="end-footer">
      <div className="P-T-C">
        <h6>
          Copyright © {currentYear} Meylah Corporation. All rights reserved.
        </h6>
        <div className="sub-P-T-C">
          <a href="http://meylah.com/privacy-policy/" target="_blank">
            <p className="PrivacyPolicy">Privacy Policy</p>
          </a>
          |
          <a href="http://meylah.com/termsofuse/" target="_blank">
            <p className="TermsAndConditions">Terms & Conditions</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyTermsConditions;
